module.exports = __webpack_public_path__ + "static/media/newuserbadge.8a4dba24.svg";